var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _vm._v(
          "Таблица, показывающая сколько бы составлял доход по указанным процентам"
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "Фактическая сумма мотивации (без учета ставки): " +
            _vm._s(_vm.totalEarnMotivate)
        )
      ]),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "mt-3",
        attrs: { items: _vm.stats, fields: _vm.columns }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f01342a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f01342a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatsWorkshopScreenM.vue
// module id = null
// module chunks = 